import { Renditions } from "@components/Product/ProductImage/mappedRenditions";

export enum ProductTileChildComponent {
    PRODUCT_IMAGE = "PRODUCT_IMAGE",
    CATEGORY_LINK = "CATEGORY_LINK",
    PROMOTION_RIBBON = "PROMOTION_RIBBON",
    PROMOTION_LABEL = "PROMOTION_LABEL",
    WISHLIST_BUTTON = "WISHLIST_BUTTON",
    BRAND = "BRAND",
    TITLE = "TITLE",
    FEATURES = "FEATURES",
    COMPARISON = "COMPARISON",
    PRODUCT_PRICE = "PRODUCT_PRICE",
    DELIVERY_TYPES = "DELIVERY_TYPES",
    BUTTON = "BUTTON",
    EXTRA_BUTTONS = "EXTRA_BUTTONS",
    REVIEWS = "REVIEWS",
}

export type ProductTileConfig = {
    border?: boolean;
    tilePadding?: boolean;
    horizontal?: boolean;
    amountOfFeatures: number;
    imageRenditions?: Renditions;
    hoverEffect?: boolean;
    components: Array<Array<Array<ProductTileChildComponent>>>;
    columnFractions?: Array<number>;
};

const row = (row: Array<ProductTileChildComponent>) => (include: boolean) =>
    include ? [row] : [];

// cols[col[rows[...components]]
export const ProductTileLayout = {
    PLP: (buttons: boolean, categoryLink: boolean) => [
        [
            [ProductTileChildComponent.PRODUCT_IMAGE],
            ...row([ProductTileChildComponent.CATEGORY_LINK])(categoryLink),
            [
                ProductTileChildComponent.PROMOTION_RIBBON,
                ProductTileChildComponent.PRODUCT_PRICE,
            ],
            [ProductTileChildComponent.TITLE],
            [ProductTileChildComponent.DELIVERY_TYPES],
            [ProductTileChildComponent.FEATURES],
            [ProductTileChildComponent.REVIEWS],
            ...row([
                ProductTileChildComponent.BUTTON,
                ProductTileChildComponent.WISHLIST_BUTTON,
            ])(buttons),
            [ProductTileChildComponent.COMPARISON],
        ],
    ],
    PLP_HORIZONTAL: (buttons: boolean, categoryLink: boolean) => [
        [
            [ProductTileChildComponent.PRODUCT_IMAGE],
            [ProductTileChildComponent.PRODUCT_PRICE],
            [ProductTileChildComponent.DELIVERY_TYPES],
        ],
        [
            ...row([ProductTileChildComponent.CATEGORY_LINK])(categoryLink),
            [ProductTileChildComponent.TITLE],
            [ProductTileChildComponent.PROMOTION_LABEL],
            [ProductTileChildComponent.FEATURES],
            [ProductTileChildComponent.REVIEWS],
            ...row([
                ProductTileChildComponent.BUTTON,
                ProductTileChildComponent.WISHLIST_BUTTON,
            ])(buttons),
            [ProductTileChildComponent.COMPARISON],
        ],
    ],
    AEM: (buttons: boolean, categoryLink: boolean) => [
        [
            [ProductTileChildComponent.PRODUCT_IMAGE],
            ...row([ProductTileChildComponent.CATEGORY_LINK])(categoryLink),
            [
                ProductTileChildComponent.PROMOTION_RIBBON,
                ProductTileChildComponent.PRODUCT_PRICE,
            ],
            [ProductTileChildComponent.TITLE],
            [ProductTileChildComponent.FEATURES],
            [ProductTileChildComponent.REVIEWS],
            ...row([
                ProductTileChildComponent.BUTTON,
                ProductTileChildComponent.WISHLIST_BUTTON,
            ])(buttons),
        ],
    ],
    WISHLIST: () => [
        [
            [ProductTileChildComponent.PRODUCT_IMAGE],
            [
                ProductTileChildComponent.PROMOTION_RIBBON,
                ProductTileChildComponent.PRODUCT_PRICE,
            ],
            [ProductTileChildComponent.TITLE],
            [ProductTileChildComponent.REVIEWS],
            [
                ProductTileChildComponent.BUTTON,
                ProductTileChildComponent.EXTRA_BUTTONS,
                ProductTileChildComponent.WISHLIST_BUTTON,
            ],
        ],
    ],
    WISHLIST_HORIZONTAL: () => [
        [[ProductTileChildComponent.PRODUCT_IMAGE]],
        [
            [ProductTileChildComponent.TITLE],
            [
                ProductTileChildComponent.PROMOTION_LABEL,
                ProductTileChildComponent.PRODUCT_PRICE,
            ],
            [ProductTileChildComponent.REVIEWS],
            [
                ProductTileChildComponent.BUTTON,
                ProductTileChildComponent.EXTRA_BUTTONS,
                ProductTileChildComponent.WISHLIST_BUTTON,
            ],
        ],
    ],
    SEARCH: () => [
        [
            [ProductTileChildComponent.PRODUCT_IMAGE],
            [ProductTileChildComponent.TITLE],
            [
                ProductTileChildComponent.PROMOTION_LABEL,
                ProductTileChildComponent.PRODUCT_PRICE,
            ],
            [ProductTileChildComponent.REVIEWS],
        ],
    ],
    COMPARISON: () => [
        [
            [ProductTileChildComponent.PRODUCT_IMAGE],
            [ProductTileChildComponent.TITLE],
            [
                ProductTileChildComponent.PROMOTION_LABEL,
                ProductTileChildComponent.PRODUCT_PRICE,
            ],
            [ProductTileChildComponent.REVIEWS],
            [ProductTileChildComponent.BUTTON],
        ],
    ],
    COMPARISON_BAR_HORIZONTAL: () => [
        [[ProductTileChildComponent.PRODUCT_IMAGE]],
        [
            [ProductTileChildComponent.TITLE],
            [
                ProductTileChildComponent.PROMOTION_LABEL,
                ProductTileChildComponent.PRODUCT_PRICE,
            ],
            [ProductTileChildComponent.REVIEWS],
        ],
    ],
    BUNDLE: () => [
        [
            [ProductTileChildComponent.PRODUCT_IMAGE],
            [ProductTileChildComponent.TITLE],
            [ProductTileChildComponent.PROMOTION_LABEL],
            [ProductTileChildComponent.PRODUCT_PRICE],
            [ProductTileChildComponent.REVIEWS],
        ],
    ],
    SLIDER: (button: boolean, categoryLink: boolean, features: boolean) => [
        [
            [ProductTileChildComponent.PRODUCT_IMAGE],
            ...row([ProductTileChildComponent.CATEGORY_LINK])(categoryLink),
            [ProductTileChildComponent.TITLE],
            ...row([ProductTileChildComponent.FEATURES])(features),
            [
                ProductTileChildComponent.PROMOTION_LABEL,
                ProductTileChildComponent.PRODUCT_PRICE,
            ],
            [ProductTileChildComponent.REVIEWS],
            ...row([ProductTileChildComponent.BUTTON])(button),
        ],
    ],
};
